import { htmlDecode } from "../../../../../utils/parse";

function getStatusColor(status, isSelected) {
  if(!isSelected)
    return "linear-gradient(90deg, #ddd 32.75%, #FFFFFF 96.35%)";
  return (
    {
      correct: "linear-gradient(90deg, #7EB6A2 32.75%, #FFFFFF 96.35%)",
      incorrect: "linear-gradient(90deg, #FF675E 32.75%, #FFFFFF 96.35%)",
      unchecked: "linear-gradient(90deg, #8FA3B8 32.75%, #FFFFFF 96.35%)",
    }[status] || "linear-gradient(90deg, #ddd 32.75%, #FFFFFF 96.35%)"
  );
}

export function QuestionOptions({ options, selectedOptionId, status }) {
  return (
    <div>
      <div className="label">Options</div>
      <div>
        {options.map((opt, ind) => {
          return (
            <div
              key={opt.optionId}
              style={{
                display: "flex",
                gap: "5px",
                fontSize: "1rem",
                marginBottom: "5px",
                background: getStatusColor(status, opt.optionId === selectedOptionId),
              }}
            >
              <div style={{ width: "50px", padding: "0px 5px" }}>
                {String.fromCharCode(65 + ind)}
              </div>

              <div
                className="option_content"
                dangerouslySetInnerHTML={{
                  __html: htmlDecode(opt.value),
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
